module.exports = __webpack_public_path__ + "static/media/ami_img_mobile.2bfe7721.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_img_mobile.png
// module id = 1443
// module chunks = 1